import React from 'react';
import {styled} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

const CustomButton = ({
  sx,
  children,
  size = 'large',
  color = 'primary',
  variant = 'contained',
  loading = false,
  onClick = () => {},
  ...otherProps
}) => {
  return (
    <CustomizedBtn
      size={size}
      variant={variant}
      sx={sx}
      color={color}
      onClick={onClick}
      loading={loading}
      {...otherProps}>
      {children}
    </CustomizedBtn>
  );
};

const CustomizedBtn = styled(LoadingButton)`
  border-radius: 1rem;
`;

export default CustomButton;
